/* eslint no-nested-ternary:0 */
import React from 'react';
import { replace } from 'ramda';

export function ContentReviewsHeader({ shouldRender, reviewsTitle }) {
  if (!shouldRender) {
    const nextTag = reviewsTitle || 'Used Car Reviews';
    const nextTagModified =
      nextTag === reviewsTitle
        ? `${replace(/USED\s/i, '', nextTag)} Reviews`
        : nextTag;
    return (
      <h2 data-cv-test="Cv.ContentReviews.Header">
        <span>{nextTagModified}</span>
      </h2>
    );
  }

  return null;
}

export default ContentReviewsHeader;
